import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: '20px',
  overflow: 'hidden',
  marginBottom: '20px',
}));

export const StyledTable = styled(MuiTable)(() => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
}));

export const StyledTableHead = styled(TableHead)({});

export const StyledTableRowHead = styled(TableRow)({});

export const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  color: theme.palette.custom.black[30],
  textAlign: 'left',
  padding: '10px 16px',
  border: 'none',
}));

export const StyledLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  color: theme.palette.custom.black[30],
}));

export const StyledTableRow = styled(TableRow)({
  height: '57px',
});

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    !(typeof prop === 'string' && prop.startsWith('$')),
})<{
  $borderTopWidth?: string;
  $borderBottomWidth?: string;
  $borderLeftWidth?: string;
  $borderRightWidth?: string;
  $borderRadius?: string;
}>(
  ({
    $borderTopWidth,
    $borderBottomWidth,
    $borderLeftWidth,
    $borderRightWidth,
    $borderRadius,
  }) =>
    ({ theme }) => ({
      padding: '10px 16px',
      border: 'none',
      borderTop: $borderTopWidth
        ? `${$borderTopWidth} solid ${theme.palette.custom.grey6}`
        : 'none',
      borderBottom: $borderBottomWidth
        ? `${$borderBottomWidth} solid ${theme.palette.custom.grey6}`
        : 'none',
      borderLeft: $borderLeftWidth
        ? `${$borderLeftWidth} solid ${theme.palette.custom.grey6}`
        : 'none',
      borderRight: $borderRightWidth
        ? `${$borderRightWidth} solid ${theme.palette.custom.grey6}`
        : 'none',
      borderRadius: $borderRadius,
      background: 'white',
      fontWeight: 'inherit',
      fontSize: 'inherit',
    })
);
